import React, { Component } from "react";
import { Message, Icon } from "semantic-ui-react";

class Adjunto extends Component {
  state = {
    color: "blue",
    mouseOver: false
  };

  handleMouseEnter = () =>
    this.setState({
      mouseOver: true,
      color: "pink"
    });
  handleMouseLeave = () =>
    this.setState({
      mouseOver: false,
      color: "blue"
    });

  handleBorrarAdjunto = () => {
    const { id, fileName } = this.props;
    this.props.handleBorrarAdjunto({
      fileName,
      idAdjunto: id
    });
  };

  render() {
    return (
      <Message
        onDismiss={this.handleBorrarAdjunto}
        color={this.state.color}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <Icon name="file outline" />
        <a href={this.props.url} target="_blank" rel="noopener noreferrer">
          {this.state.mouseOver ? (
            <strong>{this.props.fileName}</strong>
          ) : (
            this.props.fileName
          )}
        </a>
      </Message>
    );
  }
}
export default Adjunto;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/inscripcionConfirmada/Adjunto.jsx